import { IAssetOwnerState } from '@/modules/assetOwner/store/state';
import { IRootState } from '@/store/state';
import { GetterTree } from 'vuex';
import { TimePeriod } from '@/modules/fund/types';
import { AllAnalysisData } from '@/modules/costAnalysis/types';
import { PensionScheme } from '../types';

/**
 * --------------------------------------------------
 *	Asset Owner Getters
 * --------------------------------------------------
 **/
export const AssetOwnerGetters: IAssetOwnerGetters = {
  rootInvestmentId: (state: IAssetOwnerState): string | null =>
    state.rootInvestmentId,
  selectedTimePeriod: (state: IAssetOwnerState): TimePeriod =>
    state.selectedTimePeriod,
  costAnalysisDetails: (state: IAssetOwnerState): AllAnalysisData =>
    state.costAnalysisDetails,
  entityRootInvestments: (state: IAssetOwnerState): PensionScheme[] =>
    state.entityRootInvestments,
  entityRootInvestmentIds: (state: IAssetOwnerState): string[] =>
    state.entityRootInvestmentIds
};

/**
 * --------------------------------------------------
 *	Asset Owner Getters Interface
 * --------------------------------------------------
 **/
export interface IAssetOwnerGetters
  extends GetterTree<IAssetOwnerState, IRootState> {
  rootInvestmentId(state: IAssetOwnerState): string | null;
  selectedTimePeriod(state: IAssetOwnerState): TimePeriod;
  costAnalysisDetails(state: IAssetOwnerState): AllAnalysisData;
}
